function formatLabel(input) {
  if (!input) return ""; // Handle empty or null input
  return input
    .split("_") // Split the string by underscores
    .map((word, index) => {
      if (index === 0) {
        // Capitalize the first word
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      // Keep other words lowercase
      return word.toLowerCase();
    })
    .join(" "); // Join the words with spaces
}

const selectProps = ({
  name,
  value = "",
  options = [],
  required = true,
  disabled,
  width = "28.5vh",
  height = "4vh",
  mHeight = "5vh",
}) => ({
  name,
  label: formatLabel(name),
  value,
  required,
  disabled,
  options,
  errors: null,
  inputType: "SelectInput",
  width,
  height,
  mHeight,
});
const textProps = ({
  name,
  type,
  inputMode,
  value = "",
  helperTxt = "",
  min = 0,
  max = Infinity,
  minLength,
  maxLength,
  label = null,
  required = true,
  integer = false,
  disabled = false,
  nested = false,
  width = "12.5vh",
  mWidth,
  inputType,
  height = "4vh",
  mHeight = "5vh",
  onChangeHandler = null,
  validator = null,
  handleValidation,
}) => ({
  type,
  inputMode,
  name,
  label: label || formatLabel(name),
  value,
  min,
  max,
  minLength,
  maxLength,
  integer,
  required,
  disabled,
  helperTxt,
  errors: null,
  inputType: inputType || "TextInput",
  width,
  height,
  mWidth,
  mHeight,
  onChangeHandler: onChangeHandler
    ? onChangeHandler
    : nested
    ? "handleNestedChange"
    : "handleInputChange",
  validator,
  handleValidation: handleValidation
    ? handleValidation
    : nested
    ? "handleNestedValidation"
    : "handleValidation",
});
const optionProps = ({
  name,
  value = "",
  options = [],
  required = true,
  disabled,
  width,
  height,
  onChangeHandler = "handleInputChange",
  handleValidation = "handleOptionsValidation",
}) => ({
  name,
  label: formatLabel(name),
  value,
  options,
  required,
  disabled,
  errors: null,
  inputType: "OptionsInput",
  width,
  height,
  onChangeHandler,
  handleValidation,
});
const textAreaProps = ({
  name,
  label,
  value = "",
  required = true,
  disabled,
  minLength = 0,
  maxLength,
  helperTxt,
  width = "40vh",
  height = "15vh",
  validator,
  onChangeHandler = "handleInputChange",
  handleValidation = "handleValidation",
}) => ({
  name,
  label: label || formatLabel(name),
  value,
  minLength,
  maxLength,
  required,
  disabled,
  helperTxt,
  errors: null,
  inputType: "TextArea",
  width,
  height,
  onChangeHandler,
  validator,
  handleValidation,
});

const contactOptions = ["No preference", "Email", "Phone"];
export const contactPrefProps = () =>
  optionProps({
    name: "contact_preference",
    options: contactOptions,
    value: "No preference",
    onChangeHandler: "handleContactPreference",
  });
export const messageProps = () =>
  textAreaProps({ name: "message", minLength: 25, maxLength: 200 });

export const firstNameProps = (value) =>
  textProps({
    name: "firstname",
    value,
    maxLength: 50,
    validator: "nameValidator",
    width: "20vh",
  });
export const lastNameProps = (value) =>
  textProps({
    name: "lastname",
    value,
    maxLength: 50,
    validator: "nameValidator",
    width: "20vh",
  });
export const emailProps = () =>
  textProps({ name: "email", type: "email", width: "30vh" });
export const passwordProps = (label) =>
  textProps({
    name: "password",
    type: "password",
    label,
    width: "30vh",
  });
export const verificationCodeProps = () =>
  textProps({
    name: "verification_code",
    inputMode: "numeric",
    validator: "numericCodeValidator",
    //maxLength required
    width: "20vh",
  });

export const companyNameProps = (value) =>
  textProps({
    name: "company_name",
    value,
    maxLength: 50,
    width: "20vh",
  });
export const companyRegCodeProps = (value) =>
  textProps({
    name: "registeration_number",
    label: "Registeration no.",
    value,
    required: false,
    width: "20vh",
  });

const countriesObjects = [
  { name: "Egypt", dailingCode: "+20", countryCode: "EG" },
  { name: "Netherlands", dailingCode: "+31", countryCode: "NL" },
  { name: "United Kingdom", dailingCode: "+44", countryCode: "GB" },
];
export const dailingCodeProps = (value = "+44") =>
  selectProps({
    name: "dailing_code",
    value: value,
    options: countriesObjects,
  });
export const phoneNumberProps = (value) =>
  textProps({
    name: "phone_number",
    type: "tel",
    inputMode: "numeric",
    value,
    minLength: 7,
    maxLength: 12,
  });

const countries = ["Egypt", "Netherlands", "United Kingdom"];
export const addressFormData = ({ address = {}, required, disabled } = {}) => [
  textProps({
    name: "address_line",
    value: address.address_line || "",
    disabled: disabled,
    required: required,
    width: "35vh",
  }),
  textProps({
    name: "postcode",
    value: address.postcode || "",
    disabled: disabled,
    required: required,
    width: "15vh",
  }),
  textProps({
    name: "city",
    value: address.city || "",
    disabled: disabled,
    required: required,
    width: "20vh",
  }),
  selectProps({
    name: "country",
    options: countries,
    value: address.country || "",
    disabled: disabled,
    required: required,
    width: "20vh",
  }),
];
